import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { QuestionRequest } from 'model/request';
import { RootState } from '../store/store';
import { checkDuplicateCode, updateQuestion } from '../../service/questionService';
import { message } from 'antd';
import processError from '../../utils/processError';

interface questionEditModalProps {
  visible: boolean;
  question: QuestionRequest | null | undefined;
}

const initialState: questionEditModalProps = {
  visible: false,
  question: null,
};

export const updateQuestionProcess = createAsyncThunk(
  'questionEditModal/updateQuestionProcess',
  async (_, { getState }) => {
    const state = getState() as RootState;
    const editQuestion = state.editQuestionModal.question; // Get the current state

    try {
      if (!editQuestion) return;

      if (editQuestion.code) {
        const isDuplicateCode = await checkDuplicateCode(editQuestion.id, editQuestion.code);
        if (isDuplicateCode) {
          message.error('Mã câu hỏi đã tồn tại.');
          return;
        }
      }
      await updateQuestion(editQuestion);
      message.success('Cập nhật câu hỏi thành công');
    } catch (err) {
      processError(err);
    }
  },
);

const editQuestionModalSlice = createSlice({
  name: 'questionEditModal',
  initialState,
  reducers: {
    showEditQuestionModal: (state, action: PayloadAction<QuestionRequest | undefined>) => {
      state.visible = true;
      state.question = action.payload;
    },
    updateEditQuestion(state, action: PayloadAction<QuestionRequest>) {
      if (!state.question) return;

      state.question.code = action.payload.code;
      state.question.exerciseFormats = action.payload.exerciseFormats;
      state.question.skillTypes = action.payload.skillTypes;
      state.question.topic = action.payload.topic;
      state.question.hint = action.payload.hint;
      state.question.solutionGuide = action.payload.solutionGuide;
      state.question.type = action.payload.type;
      state.question.thinkingLevels = action.payload.thinkingLevels;
      state.question.rightAnswer = action.payload.rightAnswer;
      state.question.questionDetails = action.payload.questionDetails;
      state.question.questionIndex = action.payload.questionIndex;
    },
    closeEditQuestionModal: (state) => {
      state.question = null;
      state.visible = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateQuestionProcess.fulfilled, (state) => {
      state.question = null;
      state.visible = false;
    });
  },
});

export const { showEditQuestionModal, updateEditQuestion, closeEditQuestionModal } = editQuestionModalSlice.actions;

export default editQuestionModalSlice;
